import React from 'react';
import Icon from '../../../components/AppIcon';

const CalculationStatus = ({ status }) => {
  if (!status || status?.state === 'idle') {
    return null;
  }

  const getStatusConfig = () => {
    switch (status?.state) {
      case 'processing':
        return {
          icon: 'Loader',
          iconClass: 'animate-spin text-primary',
          bgClass: 'bg-primary/10 border-primary/20',
          title: 'Processing Results',
          description: `Calculating points for ${status?.currentMatch} of ${status?.totalMatches} matches...`
        };
      case 'success':
        return {
          icon: 'CheckCircle',
          iconClass: 'text-success',
          bgClass: 'bg-success/10 border-success/20',
          title: 'Calculation Complete',
          description: `Successfully processed ${status?.totalMatches} match${status?.totalMatches !== 1 ? 'es' : ''} and updated ${status?.affectedUsers} user leaderboards`
        };
      case 'error':
        return {
          icon: 'AlertCircle',
          iconClass: 'text-error',
          bgClass: 'bg-error/10 border-error/20',
          title: 'Calculation Error',
          description: status?.errorMessage || 'An error occurred during points calculation'
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div className={`rounded-lg border p-4 md:p-6 ${config?.bgClass}`}>
      <div className="flex items-start gap-4">
        <Icon name={config?.icon} size={24} className={config?.iconClass} />
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-1">
            {config?.title}
          </h4>
          <p className="text-sm text-muted-foreground">
            {config?.description}
          </p>
          
          {status?.state === 'processing' && (
            <div className="mt-4">
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div 
                  className="bg-primary h-full transition-all duration-300"
                  style={{ width: `${(status?.currentMatch / status?.totalMatches) * 100}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground mt-2">
                {Math.round((status?.currentMatch / status?.totalMatches) * 100)}% complete
              </p>
            </div>
          )}

          {status?.state === 'error' && status?.failedMatches && (
            <div className="mt-3">
              <p className="text-xs font-medium text-foreground mb-2">
                Failed Matches:
              </p>
              <div className="space-y-1">
                {status?.failedMatches?.map((match, index) => (
                  <p key={index} className="text-xs text-muted-foreground">
                    • Match #{match?.matchNumber}: {match?.error}
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalculationStatus;